import { compact } from '../../../../helpers/compact';
import { HomeTile } from '../../../../types/slice';
import { toImage, toLink, toText } from '../../fields';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const homeTile = (data: Record<string, any>): HomeTile =>
  compact({
    image: toImage(data.image),
    title: toText(data.title),
    subtitle: toText(data.subtitle),
    ctaLabel: toText(data.ctaLabel),
    ctaLink: toLink(data.ctaLink),
  });

export default homeTile;
